<template>
	<section class="app-main" style="min-height: 100%">
		<transition name="fade" mode="out-in">
			<router-view :key="key"></router-view>
		</transition>
	</section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  }
}
</script>

<style>
	.app-main{
		padding-top: 15px;
		padding-left: 10px;
		padding-right: 10px;
		padding-bottom: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/AppMain.vue?6c146f80